import { angular, app } from '../../app.module'
app
  // アカウントの投稿一覧の表示用のディレクティブ
  .directive('accountPost', () => {
    return {
      template: require('./account-post.pug')(),
      restrict: 'E',
      controller: function (
        $rootScope,
        $scope,
        $attrs,
        PostService,
        AccountChangeService,
        RestangularService
      ) {
        $scope.paramsPostList = JSON.parse(JSON.stringify($scope.getOptions))

        if ($attrs.type === 'accountModal') {
          $scope.paramsPostList.targetInfo = AccountChangeService.Init.targetInfo
        }
        $scope.state = 'postList'
        $scope.accountModalFlg = true
        // アカウント情報を表示するフラグ
        $scope.showAccountInfoFlg = $attrs.showAccountInfoFlg
        $scope.parentState = $attrs.parentState
        $scope.selectedTab = $scope.snsType

        // テーブルクエリ設定
        $scope.query = {
          order: $scope.snsType === 'tiktok' ? 'plays' : 'engagements',
          limit: 25,
          options: [10, 25, 50],
          page: 1,
          postsCount: null,
        }
        if ($scope.snsType === 'youtube') {
          $scope.query.order = 'views'
        }

        /**
         * backToPostList 投稿一覧に戻るイベント
         */
        $scope.backToPostList = function () {
          $scope.state = 'postList'
          // スクロールの位置をセット
          setTimeout(function () {
            angular.element('md-dialog-content').scrollTop($scope.scrollPosition)
          })
        }

        /**
         * showPostTagedit 投稿タグ編集画面を表示
         * @param {string} postId 投稿ID
         */
        $scope.showPostTagedit = function (postId: string) {
          // スクロールの位置を保存
          $scope.scrollPosition = angular.element('md-dialog-content').scrollTop()
          $scope.postId = postId
          $scope.state = 'tagEdit'
        }

        /**
         * showPostMemoEdit 投稿のメモ管理画面を表示
         * @param {string} postId 投稿ID
         */
        $scope.showPostMemoEdit = function (postId: string) {
          // スクロールの位置を保存
          $scope.scrollPosition = angular.element('md-dialog-content').scrollTop()
          $scope.postId = postId
          $scope.state = 'memoEdit'
        }

        /**
         * setOptions 取得するオプションを追加
         * @param {object} getOptions 取得するオプション
         * @return 取得するオプション
         */
        function setOptions() {
          $scope.paramsPostList.limit = $scope.query.limit
          $scope.paramsPostList.order = $scope.query.order
          $scope.paramsPostList.page = $scope.query.page
          $scope.paramsPostList.postsCount = $scope.query.postsCount
        }

        /**
         * getAccountPostData アカウントの投稿一覧を取得する
         */
        function getAccountPostData() {
          $scope.isLoading = true
          $scope.isEmpty = false
          // 取得するオプションをセット
          setOptions()

          let setPosts

          switch ($scope.snsType) {
            case 'facebook':
              setPosts = PostService.FbPost.setFbPosts
              break

            case 'twitter':
              setPosts = PostService.TwPost.setTwPosts
              break

            case 'instagram':
              setPosts = PostService.InPost.setInPosts
              break

            case 'youtube':
              setPosts = PostService.YtPost.setYtPosts
              break

            case 'line':
              setPosts = PostService.LinePost.setLinePosts
              break

            case 'tiktok':
              setPosts = PostService.TikTokPost.setTikTokPosts
              break
          }

          // 投稿一覧を取得
          RestangularService.request('GET', '/post/list', {
            options: JSON.stringify($scope.paramsPostList),
            snsType: $scope.snsType,
          }).then((result) => {
            const posts = result[0].data

            if ($scope.paramsPostList.postsCount === null && posts !== null && posts.length > 0) {
              // データの平均と投稿件数を取得
              RestangularService.request('GET', 'post/list', {
                options: JSON.stringify($scope.paramsPostList),
                snsType: $scope.snsType,
                type: 'average',
              }).then((result) => {
                const averageData = result[0].data

                $scope.query.postsCount = averageData.postsCount
                $scope.paramsPostList.postsCount = averageData.postsCount
                $scope.postsDataAverage = averageData.postsDataAverage
              })
            }

            // 投稿一覧
            $scope.sortPosts = setPosts(posts)

            // ローディング中フラグはfalseにセット
            $scope.isLoading = false
            if ($scope.sortPosts.length === 0) {
              setTimeout(() => {
                $scope.$apply(() => {
                  $scope.isEmpty = true
                })
              }, 500)
            }
          })
        }

        getAccountPostData()

        /**
         * onPaginate ページングを移動するイベント
         * @param {number} page 現在のページ
         * @param {number} limit 一ページの件数
         */
        $scope.onPaginate = function (page, limit) {
          $scope.query.page = page
          $scope.query.limit = limit
          getAccountPostData()
        }

        /**
         * onReorder ソートのイベント
         * @param {string} order ソート対象
         */
        $scope.onReorder = function (order) {
          // ページングを初期化
          $scope.query.page = 1
          $scope.query.order = order
          getAccountPostData()
        }

        $scope.$watch(
          () => {
            return $scope.paramsPostList
          },
          () => {
            $rootScope.$broadcast('changeParamPost', {
              getOptions: $scope.paramsPostList,
            })
          },
          true
        )

        $scope.$watch(
          () => {
            return $scope.sortPosts
          },
          () => {
            const updateIsNoPost = $scope.$parent[$attrs.updateIsNoPost]

            if (typeof updateIsNoPost === 'function') {
              updateIsNoPost(!$scope.sortPosts || $scope.sortPosts.length === 0)
            }
          }
        )

        /**
         * 対象日付の変更を検知してグラフ設定
         */
        $scope.$on('changeDateRange', (event, startEndDate) => {
          // date-range-pickerで期間を指定した場合、セット
          if (startEndDate.startDate !== undefined && startEndDate.endDate !== undefined) {
            $scope.paramsPostList.startEndDate = startEndDate
            // テーブルクエリ設定
            $scope.query = {
              order: 'engagements',
              limit: 25,
              options: [10, 25, 50],
              page: 1,
              postsCount: null,
            }
            if ($scope.snsType === 'youtube') {
              $scope.query.order = 'views'
            }

            getAccountPostData()
          }
        })
      },
    }
  })
